import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, from, lastValueFrom } from 'rxjs';
import { AuthService } from 'src/services/auth.service';
import { AppNav } from 'src/routes/app-nav';
import { COOKIE_KEYS, ERROR_CODES } from 'src/shared/constants';
import CookieHelpers from 'src/shared/cookie-helper';

@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return from(this.handle(req, next));
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {
    req = req.clone({
      withCredentials: true,
      url: req.url,
    });

    return await lastValueFrom(
      next.handle(req).pipe(
        catchError(async (err) => {
          if (err instanceof HttpErrorResponse) {
            const { concurrentLogin } = ERROR_CODES;

            const errorCode =
              err.error instanceof Blob
                ? JSON.parse(await err.error.text())?.code
                : err.error.code;

            if (err.status === 401) {
              if (errorCode === concurrentLogin) {
                CookieHelpers.setCookie(
                  COOKIE_KEYS.concurrentLogin,
                  ERROR_CODES.concurrentLogin,
                  1
                );
                this.authService.logout(concurrentLogin);
              } else {
                this.router.navigateByUrl('/' + 'login');
              }
            } else if (err.status === 403) {
              debugger;
              this.router.navigateByUrl('/' + AppNav.AccessDenied.route);
            } else if (err.url && err.url.indexOf('/login') > -1) {
              this.router.navigateByUrl('/' + 'login');
            }
          }

          throw err;
        })
      )
    );
  }
}
